export function getExtension(file: string): string
{
    return (<string>file.split('.').pop()).toLowerCase();
}

export function removeExtension(file: string): string
{
    const extension = getExtension(file);
    if (!extension)
    {
        return file;
    }

    return file.replace('.' + extension, '');
}

export function isImage(file: string)
{
    return [
        'bmp',
        'gif',
        'jpg',
        'jpeg',
        'png',
        'webp',
    ].includes(getExtension(file));
}

// @see: module/Data/src/Data/Controller/IndexController.php:405
export function isInlineFile(file: string)
{
    return [
        // default inline files
        'pdf',
        'txt',
        // default inline images
        'jpg',
        'jpeg',
        'bmp',
        'gif',
        'png',
        'webp',
        // videos
        '3gp',
        'ts',
        'mp4',
        'mpeg',
        'mpg',
        'mov',
        'webm',
        'flv',
        'm4v',
        'mng',
        'asx',
        'asf',
        'wmv',
        'avi',
    ].includes(getExtension(file));
}

export function fileDefinition(type: string): FileDefinition
{
    // ensure type is only the extens [if filename was given]
    type = getExtension(type);

    // list from \Portuna\Intranet::getFileInformation
    // @formatter:off
    let definition        = {"pdf":{"type":"pdf","icon":"picture_as_pdf","color":"187,7,6"},"php":{"type":"php","icon":"code","color":"92,179,84"},"txt":{"type":"txt","icon":"attach_file","color":"140,140,140"},"flv":{"type":"flv","icon":"videocam","color":"29,161,201"},"wav":{"type":"wav","icon":"audiotrack","color":"48,85,171"},"jpeg":{"type":"jpeg","icon":"image","color":"207,41,107"},"ppt":{"type":"ppt","icon":"attach_file","color":"210,70,37"},"xls":{"type":"xls","icon":"attach_file","color":"32,114,69"},"docx":{"type":"docx","icon":"attach_file","color":"40,83,149"},"7z":{"type":"7z","icon":"archive","color":"251,207,40"},"js":{"type":"js","icon":"code","color":"92,179,84"},"html":{"type":"html","icon":"code","color":"92,179,84"},"css":{"type":"css","icon":"code","color":"92,179,84"},"cpp":{"type":"cpp","icon":"code","color":"92,179,84"},"java":{"type":"java","icon":"code","color":"92,179,84"},"c":{"type":"c","icon":"code","color":"92,179,84"},"actionscript":{"type":"actionscript","icon":"code","color":"92,179,84"},"cmd":{"type":"cmd","icon":"code","color":"92,179,84"},"cs":{"type":"cs","icon":"code","color":"92,179,84"},"phtml":{"type":"phtml","icon":"code","color":"92,179,84"},"xhtml":{"type":"xhtml","icon":"code","color":"92,179,84"},"xml":{"type":"xml","icon":"code","color":"92,179,84"},"lua":{"type":"lua","icon":"code","color":"92,179,84"},"pyo":{"type":"pyo","icon":"code","color":"92,179,84"},"log":{"type":"log","icon":"attach_file","color":"179,179,179"},"odt":{"type":"odt","icon":"attach_file","color":"179,179,179"},"rtf":{"type":"rtf","icon":"attach_file","color":"179,179,179"},"mpeg":{"type":"mpeg","icon":"videocam","color":"29,161,201"},"mpg":{"type":"mpg","icon":"videocam","color":"29,161,201"},"swf":{"type":"swf","icon":"videocam","color":"29,161,201"},"wmv":{"type":"wmv","icon":"videocam","color":"29,161,201"},"json":{"type":"json","icon":"code","color":"92,179,84"},"cnf":{"type":"cnf","icon":"attach_file","color":"179,179,179"},"conf":{"type":"conf","icon":"attach_file","color":"179,179,179"},"cfg":{"type":"cfg","icon":"attach_file","color":"179,179,179"},"mp4":{"type":"mp4","icon":"videocam","color":"29,161,201"},"wma":{"type":"wma","icon":"audiotrack","color":"48,85,171"},"mp3":{"type":"mp3","icon":"audiotrack","color":"48,85,171"},"aac":{"type":"aac","icon":"audiotrack","color":"48,85,171"},"cr2":{"type":"cr2","icon":"image","color":"207,41,107"},"jpg":{"type":"jpg","icon":"image","color":"207,41,107"},"gif":{"type":"gif","icon":"image","color":"207,41,107"},"bmp":{"type":"bmp","icon":"image","color":"207,41,107"},"png":{"type":"png","icon":"image","color":"207,41,107"},"tga":{"type":"tga","icon":"image","color":"207,41,107"},"psd":{"type":"psd","icon":"image","color":"207,41,107"},"pdn":{"type":"pdn","icon":"image","color":"207,41,107"},"pdd":{"type":"pdd","icon":"image","color":"207,41,107"},"pptx":{"type":"pptx","icon":"attach_file","color":"210,70,37"},"pptm":{"type":"pptm","icon":"attach_file","color":"210,70,37"},"xl":{"type":"xl","icon":"attach_file","color":"32,114,69"},"pps":{"type":"pps","icon":"attach_file","color":"210,70,37"},"ppsx":{"type":"ppsx","icon":"attach_file","color":"210,70,37"},"xlr":{"type":"xlr","icon":"attach_file","color":"32,114,69"},"docm":{"type":"docm","icon":"attach_file","color":"40,83,149"},"doc":{"type":"doc","icon":"attach_file","color":"40,83,149"},"dot":{"type":"dot","icon":"attach_file","color":"40,83,149"},"rar":{"type":"rar","icon":"archive","color":"251,207,40"},"zip":{"type":"zip","icon":"archive","color":"209,131,0"},"xlsx":{"type":"xlsx","icon":"attach_file","color":"32,114,69"},"webp":{"type":"webp","icon":"image","color":"207,41,107"}};
    // @formatter:on
    let defaultDefinition = {
        'type': 'default',
        'icon': 'attach_file',
        'color': '102,102,102',
    };

    return 'undefined' !== typeof definition[type] ? definition[type] : defaultDefinition;
}

export function fileIcon(type: string): string
{
    return fileDefinition(type).icon;
}

export const WEB_STORAGE_DIR       = '/data/';
export const WEB_STORAGE_IMAGE_DIR = WEB_STORAGE_DIR + 'image/';
export const WEB_STORAGE_FILE_DIR  = WEB_STORAGE_DIR + 'file/';

export const UPLOAD_TYPE_FILE  = 0;
export const UPLOAD_TYPE_IMAGE = 1;
export const LINK_ICON: FileDefinition = {
    type: 'link',
    icon: 'link',
    color: '207,41,107',
};